export default __webpack_public_path__ + "static/media/Menu.78ab3d56.svg";